(() => {
  'use strict';
  if (window.__liaBlogCards) return;
  window.__liaBlogCards = true;
  const root = document.querySelector('[data-lia-blog-tracking]');
  if (!root) return;
  const article = root.dataset.liaBlogTracking;
  const locale = document.documentElement.lang || 'en';
  const debug = new URLSearchParams(location.search).get('lia_tracking_debug') === '1';
  const preview = Boolean(window.Shopify?.designMode || window.Shopify?.theme?.role !== 'main');
  if (preview && !debug) return;
  const cards = new Map();
  const visible = new Set();
  const seen = new Set();
  const timers = new Map();
  const clicked = new Map();
  let observer;

  function allowed() {
    try { return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true; }
    catch (_) { return false; }
  }
  function productFrom(link) {
    try {
      const url = new URL(link.href, location.origin);
      if (url.origin !== location.origin) return null;
      return url.pathname.match(/\/products\/([^/]+)\/?$/)?.[1] || null;
    } catch (_) { return null; }
  }
  function publish(name, card) {
    if (!allowed() || !window.Shopify?.analytics?.publish) return false;
    const data = { ...cards.get(card), article_handle: article, locale,
      experiment_id: 'blog_cards_v1', debug_mode: debug };
    try {
      const result = window.Shopify.analytics.publish('lia:' + name, data);
      if (result?.catch) result.catch(() => {});
      return result !== false;
    } catch (_) { return false; }
  }
  function cancel(card) {
    clearTimeout(timers.get(card));
    timers.delete(card);
  }
  function schedule(card) {
    if (seen.has(card) || timers.has(card) || document.hidden || !allowed()) return;
    timers.set(card, setTimeout(() => {
      timers.delete(card);
      if (!document.hidden && visible.has(card) && publish('blog_product_view', card)) {
        seen.add(card);
        observer?.unobserve(card);
      }
    }, 1000));
  }
  function refresh() {
    if (!allowed() || document.hidden) {
      timers.forEach((_, card) => cancel(card));
      return;
    }
    visible.forEach(schedule);
  }
  root.querySelectorAll('.product-recommendation-cards > div, [data-article-product-card]').forEach(card => {
    const link = card.querySelector('a[href]');
    const product = link && productFrom(link);
    if (!product || cards.has(card)) return;
    cards.set(card, { product_handle: product, card_position: cards.size + 1 });
  });
  if ('IntersectionObserver' in window) {
    observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
          visible.add(entry.target);
          schedule(entry.target);
        } else {
          visible.delete(entry.target);
          cancel(entry.target);
        }
      });
    }, { threshold: [0, 0.5] });
    cards.forEach((_, card) => observer.observe(card));
  }
  function onClick(event) {
    if (event.type === 'auxclick' && event.button !== 1) return;
    const link = event.target.closest?.('a[href]');
    if (!link || !allowed()) return;
    for (const [card, data] of cards) {
      if (!card.contains(link) || productFrom(link) !== data.product_handle) continue;
      const now = Date.now();
      if (now - (clicked.get(card) || 0) < 800) return;
      if (publish('blog_product_click', card)) clicked.set(card, now);
      return;
    }
  }
  root.addEventListener('click', onClick);
  root.addEventListener('auxclick', onClick);
  document.addEventListener('visibilitychange', refresh);
  document.addEventListener('visitorConsentCollected', refresh);
  // Privacy and pixel APIs may arrive after the deferred theme script.
  let attempts = 0;
  const retry = setInterval(() => {
    refresh();
    if (++attempts >= 30 || (allowed() && window.Shopify?.analytics?.publish)) clearInterval(retry);
  }, 1000);
  window.addEventListener('pagehide', () => {
    clearInterval(retry);
    timers.forEach((_, card) => cancel(card));
  });
  window.addEventListener('pageshow', refresh);
})();
